import hdsClient from "@/core/http/clients/hdsClient";
import {AxiosResponse} from "axios";
import * as Sentry from "@sentry/vue";

export default {
    getBlob(url: string): Promise<Blob> {
        return hdsClient.get(url, {responseType: 'blob'})
            .then((response: AxiosResponse) => response.data)
            .catch(() => new Blob());
    },

    /**
     * Open a secured PDF in a new window and print it, e.g. a prescription
     * with all its pages.
     */
    printPdf(url: string): void {
        this.getBlob(url)
            .then(response => {
                const fileURL = window.URL.createObjectURL(new Blob([response], {type: response.type}));
                const printWindow = window.open(fileURL);

                if (printWindow) {
                    printWindow.onload = () => {
                        try {
                            printWindow.print();
                        } catch (e) {
                            Sentry.captureException(e);
                        }
                    };
                }
            })
            .catch(e => {
                Sentry.captureException(e);
            });
    },

    /**
     * Save a blob on the user's disk under the given filename, through the
     * download the browser runs on an anchor click — the one file saving
     * mechanism Connect has, Electron routing it to the downloads folder.
     */
    downloadBlob(filename: string, blob: Blob): void {
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");

        link.href = url;
        link.download = filename;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
    }
};
